/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable/index";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CircularProgress from "@mui/material/CircularProgress";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  calculatePacketDetails,
  calculatePacketWeight,
  confirmVirtualBins,
  createDynamicColumn,
  getAsnDetails,
  getAsnDetailsDownload,
  getBinsData,
  getBinsForPrint,
  getDeliveryPlant,
  getDynamicColumn,
  getLastAsnDetails,
  getPackageType,
  getSubModulesByRoleId,
  getUnloadingPoint,
  getVendorsListForPlanner,
  postCertificateView,
  printAsn,
  updateAsn,
  updateVehicleDetails,
} from "../../store";

// React-Select component and styling
import Select from "react-select";

// Custom css
import { Document, Page, StyleSheet, View } from "@react-pdf/renderer";
import { CSVLink } from "react-csv";
import QRCode from "react-qr-code";
import "../../index.css";

import { useReactToPrint } from "react-to-print";

import Config from "../../config/index";

// Cookies
import { Backdrop } from "@mui/material";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const styleForModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "80%", md: "80%", lg: "60%", xl: "60%" },
  height: "fit-content",
  maxHight: "60%",
  overflow: "auto",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForVerify = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForConfirmModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "80%", md: "80%", lg: "60%", xl: "60%" },
  height: "fit-content",
  maxHight: "60%",
  overflow: "auto",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForDocument = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 700, lg: 800, xl: 800 },
  height: 800,
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};
const styleForDocumentPrint = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 800, lg: 900, xl: 900 },
  // height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const printStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 370,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForQR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 196,
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForEditASN = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "80%", md: "80%", lg: "90%", xl: "90%" },
  height: "fit-content",
  maxHight: "60%",
  overflow: "auto",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    height: "100%",
    display: "flex",
    // flexDirection: "row",
    marginBottom: "50px",
    marginTop: "20px",
    // backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 2,
    padding: 2,
    flexGrow: 1,
  },
});

const styles2 = StyleSheet.create({
  page: {
    width: "100%",
    height: "100%",
    // display: "flex",
    // flexDirection: "row",
    marginBottom: "50px",
    marginTop: "20px",
    // marginLeft: "20px",

    // backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 2,
    padding: 2,
    flexGrow: 1,
  },
});

const AsnDetails = ({
  getAsnDetails,
  asnDetailsReducer,
  updateVehicleDetails,
  getBinsData,
  binsReducer,
  printAsn,
  getLastAsnDetails,
  lastAsnDetailsReducer,
  updateAsn,
  getPackageType,
  packageTypeReducer,
  calculatePacketDetails,
  packageDetailsReducer,
  getDeliveryPlant,
  getUnloadingPoint,
  deliveryPlantReducer,
  unloadingPointReducer,
  calculatePacketWeight,
  packetWeightReducer,
  getBinsForPrint,
  binsForPrintReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  confirmVirtualBins,
  getVendorsListForPlanner,
  vendorsListForPlannerReducer,
  postCertificateView,
  asnDetailsDownloadReducer,
  postCertificateViewReducer,
  getAsnDetailsDownload,
  getDynamicColumnReducer,
  getDynamicColumn,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;
  let email = loginDetails.data.email;

  let baseUrl = Config.baseUrl;
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "a3fc6986-f1c3-4b3b-bbd4-c355cf16d206";

  let asnDetailsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "a3fc6986-f1c3-4b3b-bbd4-c355cf16d206",
  );

  let updateVehicleDetailsAccess = asnDetailsModule
    ? asnDetailsModule.actionId.includes("7f4d2fe9-b375-4654-b524-e19021e4e7f0")
    : null;

  let viewAccess = asnDetailsModule
    ? asnDetailsModule.actionId.includes("ae4addf7-ba74-443b-9d60-d3063db534eb")
    : null;

  let updateAccess = asnDetailsModule
    ? asnDetailsModule.actionId.includes("b005f0a5-ae0b-4e44-a2cd-ae9037770407")
    : null;

  let printAsnAccess = asnDetailsModule
    ? asnDetailsModule.actionId.includes("2b20cffd-f6d4-43ae-9f2a-f97e3ae7fb71")
    : null;

  // let downloadAccess = asnDetailsModule
  //   ? asnDetailsModule.actionId.includes("04858fec-c68c-4e36-9d63-0f3ca81501b2")
  //   : null;

  let downloadAccess = true;

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const component2Ref = useRef();

  const handlePrint2 = useReactToPrint({
    content: () => component2Ref.current,
  });

  const [pageNoForBin, setPageNoForBin] = useState(0);
  const [rowsPerPageForBin, setRowsPerPageForBin] = useState(5);
  const [searchObjectForBin, setSearchObjectForBin] = useState(
    JSON.stringify({}),
  );
  const [paginationObjForBin, setPaginationObjForBin] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    if (globalFilter && typeof globalFilter === "object") {
      const cleanedFilter = Object.entries(globalFilter).reduce(
        (acc, [key, value]) => {
          if (value !== "") {
            // Convert specific keys to numbers
            if (key === "asnQty") {
              acc[key] = Number(value);
            } else {
              acc[key] = value;
            }
          }
          return acc;
        },
        {},
      );

      setSearchObject(JSON.stringify(cleanedFilter));
    } else {
      setSearchObject("");
    }
  };

  const importPageNoForBin = (pageIndex) => {
    setPageNoForBin(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPageForBin = (pageSize) => {
    setRowsPerPageForBin(pageSize);
  };

  const importSearchForBin = (globalFilter) => {
    setSearchObjectForBin(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [binType, setBinType] = useState("");

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Created",
      value: "Created",
    },
    {
      label: "Loading Pending",
      value: "Loading Pending",
    },
    {
      label: "Loading Done",
      value: "Loading Done",
    },
    {
      label: "Shipped",
      value: "Shipped",
    },
    {
      label: "GRN Created",
      value: "GRN Created",
    },
    {
      label: "Discrepancy",
      value: "Discrepancy",
    },
  ];
  useEffect(() => {
    setStatusSelected({
      label: statusOptions[0]?.label,
      value: statusOptions[0]?.value,
    });
  }, []);
  const [statusSelected, setStatusSelected] = useState("");
  const handleChangeStatus = (selectedOption) => {
    setStatusSelected(selectedOption);
  };

  const [state, setState] = useState({
    columns: [
      { Header: "ASN Code", accessor: "asnCode", align: "left" },
      { Header: "ASN Qty", accessor: "asnQty", align: "left" },
      { Header: "Part No", accessor: "itemCode", align: "left" },
      { Header: "Invoice No", accessor: "invoiceNo", align: "left" },
      { Header: "Grn No", accessor: "grnNumber", align: "left" },

      { Header: "Created Date", accessor: "cd", align: "left" },
      { Header: "Shipped Date", accessor: "shippedDate", align: "left" },

      {
        Header: "Status",
        accessor: "status",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },

      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],

    rows: [],
  });

  const { columns, rows } = state;

  const [binsTable, setBinsTable] = useState({
    columns: [
      { Header: "Bin No", accessor: "binCode", align: "left" },
      { Header: "Shipped Qty", accessor: "qty", align: "left" },
      { Header: "Received Qty", accessor: "receivedQty", align: "left" },
    ],
    rows: [],
  });

  const [virtualBinsTable, setVirtualBinsTable] = useState({
    columns: [
      { Header: "Bin No", accessor: "binCode", align: "left" },
      { Header: "Shipped Qty", accessor: "qty", align: "left" },
      { Header: "Received Qty", accessor: "receivedQty", align: "left" },
      {
        Header: "Status",
        accessor: "status",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Verify",
        accessor: "verify",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns: binsColumns, rows: binsRows } =
    binType === 1 ? virtualBinsTable : binsTable;

  const [singleASNDataForEdit, setSingleASNDataForEdit] = useState({});

  const [asnQtyChange, setAsnQtyChange] = useState("");

  const handleOpenEditASNModal = (data = {}) => {
    setSingleASNData(data);
    setSingleASNDataForEdit(data);
    setAsnQtyChange(data.asnQty);
    setSingleAsnPackageWeightData(data.packetWeight);
    setSingleAsnPackageDetailsData(data);
    setOpenEditASNModal(true);
  };

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
  };

  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");
  useEffect(() => {
    getVendorsListForPlanner(jwtToken);
  }, []);
  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];

    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.vendorName,
        value: vendorsListForPlanner.vendorCode,
        vendorId: vendorsListForPlanner.vendorUserId,
        email: vendorsListForPlanner.email,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [vendorsListForPlannerReducer]);

  const [partCode, setPartCode] = useState("");

  const [demandId, setDemandId] = useState("");

  const [asnCode, setAsnCode] = useState("");
  const [vendorUserId, setVendorUserId] = useState("");

  let today = new Date();

  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  let currentDate = yyyy + "-" + mm + "-" + dd;

  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  const [fileForTestCertificate, setFileForTestCertificate] = useState({});

  const handleChangeForTestCertificate = (event) => {
    setFileForTestCertificate(event.target.files[0]);
  };

  const [fileForInvoiceFile, setFileForInvoiceFile] = useState({});

  const handleChangeForInvoiceFile = (event) => {
    setFileForInvoiceFile(event.target.files[0]);
  };

  useEffect(() => {
    getPackageType(partCode, jwtToken);
  }, [partCode]);

  useEffect(() => {
    calculatePacketWeight(partCode, asnQtyChange, jwtToken);
  }, [partCode, asnQtyChange]);

  useEffect(() => {
    getDeliveryPlant(demandId, jwtToken);
  }, [demandId]);

  useEffect(() => {
    getUnloadingPoint(demandId, jwtToken);
  }, [demandId]);

  useEffect(() => {
    getBinsForPrint(asnCode, jwtToken);
  }, [asnCode]);

  const [singleDeliveryPlantData, setSingleDeliveryPlantData] = useState("");
  const [singleUnloadingPointData, setSingleUnloadingPointData] = useState("");

  const [singleAsnPackageTypeData, setSingleAsnPackageTypeData] = useState("");

  const [singleAsnPackageWeightData, setSingleAsnPackageWeightData] =
    useState("");

  const [singleAsnPackageDetailsData, setSingleAsnPackageDetailsData] =
    useState({});

  useEffect(() => {
    let data = packageTypeReducer.packageTypeData.data
      ? packageTypeReducer.packageTypeData.data
      : [];

    setSingleAsnPackageTypeData(data.packaging);
  }, [packageTypeReducer]);

  useEffect(() => {
    let data = packetWeightReducer.packetWeightData.data
      ? packetWeightReducer.packetWeightData.data
      : [];

    setSingleAsnPackageWeightData(data.packWeight);
  }, [packetWeightReducer]);

  useEffect(() => {
    let data = deliveryPlantReducer.deliveryPlantData.data
      ? deliveryPlantReducer.deliveryPlantData.data
      : [];

    setSingleDeliveryPlantData(data.deliveryPlant);
  }, [deliveryPlantReducer]);

  useEffect(() => {
    let data = unloadingPointReducer.unloadingPointData.data
      ? unloadingPointReducer.unloadingPointData.data
      : [];

    setSingleUnloadingPointData(data.unloadingPoint);
  }, [unloadingPointReducer]);

  useEffect(() => {
    let data = packageDetailsReducer.packageDetailsData.data
      ? packageDetailsReducer.packageDetailsData.data
      : [];

    setSingleAsnPackageDetailsData(data);
  }, [packageDetailsReducer]);

  useEffect(() => {
    getAsnDetails(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected
        : [{ email: email }],
      statusSelected ? statusSelected.value : "",
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [
    vendorsListForPlannerSelected,
    statusSelected,
    pageNo,
    rowsPerPage,
    searchObject,
  ]);
  useEffect(() => {
    getAsnDetailsDownload(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected
        : [{ email: email }],
      statusSelected ? statusSelected.value : "",
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [
    vendorsListForPlannerSelected,
    statusSelected,
    pageNo,
    rowsPerPage,
    searchObject,
  ]);

  const [printStatus, setPrintStatus] = useState("");
  const [virtualBinsData, setVirtualBinsData] = useState([]);

  let payload = {
    asnCode: asnCode,
    bins: [],
  };
  useEffect(() => {
    asnCode !== "" &&
      getBinsData(
        asnCode,
        virtual,
        pageNoForBin,
        rowsPerPageForBin,
        searchObjectForBin,
        jwtToken,
      );
  }, [asnCode, pageNoForBin, rowsPerPageForBin, searchObjectForBin]);

  // let loading = asnDetailsReducer.loading;

  const [printData, setPrintData] = useState([]);

  let tempAsnDetailsData = [];

  const [loading2, setLoading2] = useState(true);

  useEffect(() => {
    let asnDetailsData = asnDetailsReducer.asnDetails.data
      ? asnDetailsReducer.asnDetails.data
      : [];

    // setVirtualBinsData(binsData);
    setPaginationObj(asnDetailsReducer.asnDetails.pagination);

    setLoading2(asnDetailsReducer.loading);
    asnDetailsData.map((data) => {
      // const formatDateForShippedDate = new Date(data.shippedDate);
      const formatDateForCD = new Date(data.cd);
      const singleData = {
        // privateKey: data.asnCode,
        asnCode: data.asnCode,
        asnQty: data.asnQty,

        itemCode: data.itemCode,
        itemDescription: data.itemDescription,
        grnNumber: data.grnNumber,
        invoiceNo: data.invoiceNo,
        invoiceDoc: data.invoiceDoc,
        testCertificate: data.testCertificate,
        packageType: data.packageType,
        status: (
          <h4>
            <button
              className={
                (data.status == "Discrepancy" && `status-error`) ||
                (data.status == "GRN Created" && `status-success`) ||
                (data.status == "Created" && `status-created`) ||
                (data.status == "Loading Pending" && `status-warning`) ||
                (data.status == "Loading Done" && `status-done`) ||
                (data.status == "Shipped" && `status-warning`)
              }
              style={{ width: "5.5rem" }}
            >
              {data.status}
            </button>
          </h4>
        ),
        transporterName: data.transporterName,
        transporterType: data.transporterType,
        lrDocketno: data.lrDocketno,
        vehicleNamePlate: data.vehicleNamePlate,
        phoneNumber: data.phoneNumber,

        cd: data.cd,
        shippedDate: data.shippedDate,

        action: (
          <div>
            <div style={{ display: "flex" }}>
              {updateAccess && (
                <Tooltip title="ASN Update">
                  <MDButton
                    disabled={
                      data.status == "Shipped" ||
                      data.status == "GRN Created" ||
                      data.status == "Discrepancy" ||
                      data.status == "Loading Done"
                    }
                    variant="gradient"
                    color="success"
                    type="button"
                    iconOnly
                    size="small"
                    onClick={() => {
                      setPartCode(data.itemCode);
                      setAsnCode(data.binCode);
                      setDemandId(data.demandId);

                      handleOpenEditASNModal(data);
                    }}
                    style={{ marginRight: "5px", padding: "2%" }}
                  >
                    <Icon style={{ marginRight: "2px" }}>edit</Icon>
                  </MDButton>
                </Tooltip>
              )}

              {viewAccess && (
                <Tooltip title="View">
                  <MDButton
                    variant="gradient"
                    color="info"
                    type="button"
                    size="small"
                    onClick={() => {
                      setPartCode(data.itemCode);
                      setAsnCode(data.asnCode);
                      getBinsData(
                        data.asnCode,
                        [],
                        pageNoForBin,
                        rowsPerPageForBin,
                        searchObjectForBin,
                        jwtToken,
                      );
                      setVendorUserId(data.vendorUserId);
                      setBinType(data.isVirtualBin);
                      handleOpenViewASNModal(data);
                    }}
                    iconOnly
                    style={{ marginRight: "5px", marginBottom: "5px" }}
                  >
                    <Icon> visibility_icon </Icon>
                  </MDButton>
                </Tooltip>
              )}
            </div>

            <div style={{ display: "flex" }}>
              {data.status == "Created" ? (
                updateVehicleDetailsAccess && (
                  <Tooltip title="Confirm Details">
                    <MDButton
                      className={data.status == "Created" && `blink_me`}
                      disabled={
                        data.status == "Shipped" ||
                        data.status == "GRN Created" ||
                        data.status == "Discrepancy"
                      }
                      variant="gradient"
                      color="warning"
                      size="small"
                      type="button"
                      onClick={() => {
                        setAsnCode(data.binCode);
                        handleOpenConfirmVehicleDetailsModal(data);
                      }}
                      iconOnly
                      style={{ marginRight: "5px", marginBottom: "5px" }}
                    >
                      <Icon> local_shipping </Icon>
                    </MDButton>
                  </Tooltip>
                )
              ) : (
                <>
                  {data.status == "Shipped" ||
                  data.status == "GRN Created" ||
                  data.status == "Discrepancy"
                    ? updateVehicleDetailsAccess && (
                        <MDButton
                          // className={data.status == "Loading Pending" && `blink_me`}
                          disabled={
                            data.status == "Shipped" ||
                            data.status == "GRN Created" ||
                            data.status == "Discrepancy"
                          }
                          variant="gradient"
                          color="white"
                          type="button"
                          onClick={() => {
                            setAsnCode(data.binCode);
                            handleOpenConfirmVehicleDetailsModal(data);
                          }}
                          iconOnly
                          size="small"
                          style={{
                            marginRight: "5px",
                            marginBottom: "5px",
                            background: "#BCBCBC",
                            color: "white",
                          }}
                        >
                          <Icon> local_shipping </Icon>
                        </MDButton>
                      )
                    : updateVehicleDetailsAccess && (
                        <Tooltip title="Confirm Details">
                          <MDButton
                            // className={data.status == "Loading Pending" && `blink_me`}
                            disabled={
                              data.status == "Shipped" ||
                              data.status == "GRN Created" ||
                              data.status == "Discrepancy"
                            }
                            variant="gradient"
                            color="warning"
                            type="button"
                            onClick={() => {
                              setAsnCode(data.binCode);
                              handleOpenConfirmVehicleDetailsModal(data);
                            }}
                            iconOnly
                            size="small"
                            style={{ marginRight: "5px", marginBottom: "5px" }}
                          >
                            <Icon> local_shipping </Icon>
                          </MDButton>
                        </Tooltip>
                      )}
                </>
              )}

              {data.status == "Shipped" ||
              data.status == "GRN Created" ||
              data.status == "Discrepancy"
                ? printAsnAccess && (
                    <Tooltip title="Reprint ASN">
                      <MDButton
                        // disabled={data.status !== "Loading Done"}
                        variant="gradient"
                        // color="white"
                        style={{ background: "#0BB9B3", color: "white" }}
                        type="button"
                        onClick={() => {
                          setAsnCode(data.asnCode);
                          setPrintStatus(data.status);
                          // handlePrintAsn();
                          // printAsn(data.asnCode, jwtToken);
                          setPrintAsnDetailsPartCode(data.itemCode);
                          setPrintAsnDetailsPartDescription(
                            data.itemDescription,
                          );
                          setPrintAsnDetailsGrnNumber(data.grnNumber);
                          setPrintAsnDetailsLRNumber(data.lrDocketNo);
                          setPrintAsnDetailsTransporterName(
                            data.transporterName,
                          );
                          setPrintAsnDetailsTransporterType(
                            data.transporterType,
                          );
                          setPrintAsnDetailsVehicleNameplate(
                            data.vehicleNamePlate,
                          );
                          setPrintAsnDetailsPhoneNumber(data.phoneNumber);
                          setPrintAsnDetailsPurchaseOrderNumber(data.poNumber);
                          setPrintAsnDetailsPurchaseOrderLineNumber(
                            data.poLineNumber,
                          );
                          setPrintAsnDetailsInvoiceNo(data.invoiceNo);
                          setPrintAsnDetailsVendorCode(data.vendorCode);
                          setPrintAsnDetailsVendorName(data.vendorName);
                          setPrintAsnDetailsShippedDate(data.shippedDate);
                          setPrintAsnDetailsCreatedDate(data.cd);
                          setPrintAsnDetailsAsnQty(data.asnQty);
                          setPrintAsnDetailsPacketQty(data.packetQty);
                          setPrintAsnDetailsPacketWeight(data.packetWeight);
                          setPrintAsnDetailsInvoiceDate(data.invoiceDate);
                          handleOpenPrintASNModal(data);
                        }}
                        iconOnly
                        size="small"
                        // style={{ padding: "2%", width: "100px" }}
                      >
                        {/* Print ASN */}
                        <Icon> print </Icon>
                      </MDButton>
                    </Tooltip>
                  )
                : data.status == "Loading Done"
                  ? printAsnAccess && (
                      <Tooltip title="Print ASN">
                        <MDButton
                          disabled={data.status !== "Loading Done"}
                          className={
                            data.status == "Loading Done" && `blink_me`
                          }
                          variant="gradient"
                          style={{ background: "#0BB9B3", color: "white" }}
                          type="button"
                          onClick={() => {
                            setAsnCode(data.asnCode);
                            // handlePrintAsn();
                            printAsn(data.asnCode, jwtToken);
                            setPrintAsnDetailsPartCode(data.itemCode);
                            setPrintAsnDetailsPartDescription(
                              data.itemDescription,
                            );
                            setPrintAsnDetailsGrnNumber(data.grnNumber);
                            setPrintAsnDetailsLRNumber(data.lrDocketNo);
                            setPrintAsnDetailsTransporterName(
                              data.transporterName,
                            );
                            setPrintAsnDetailsTransporterType(
                              data.transporterType,
                            );
                            setPrintAsnDetailsVehicleNameplate(
                              data.vehicleNamePlate,
                            );
                            setPrintAsnDetailsPhoneNumber(data.phoneNumber);
                            setPrintAsnDetailsPurchaseOrderNumber(
                              data.poNumber,
                            );
                            setPrintAsnDetailsPurchaseOrderLineNumber(
                              data.poLineNumber,
                            );
                            setPrintAsnDetailsInvoiceNo(data.invoiceNo);
                            setPrintAsnDetailsVendorCode(data.vendorCode);
                            setPrintAsnDetailsVendorName(data.vendorName);
                            setPrintAsnDetailsShippedDate(data.shippedDate);
                            setPrintAsnDetailsCreatedDate(data.cd);
                            setPrintAsnDetailsAsnQty(data.asnQty);
                            setPrintAsnDetailsPacketQty(data.packetQty);
                            setPrintAsnDetailsPacketWeight(data.packetWeight);
                            setPrintAsnDetailsInvoiceDate(data.invoiceDate);
                            handleOpenPrintASNModal(data);
                          }}
                          iconOnly
                          size="small"
                          // style={{ padding: "2%", width: "100px" }}
                        >
                          {/* Print ASN */}
                          <Icon> print </Icon>
                        </MDButton>
                      </Tooltip>
                    )
                  : printAsnAccess && (
                      <MDButton
                        disabled={data.status !== "Loading Done"}
                        className={data.status == "Loading Done" && `blink_me`}
                        variant="gradient"
                        style={{ background: "#BCBCBC", color: "white" }}
                        type="button"
                        iconOnly
                        size="small"
                      >
                        <Icon> print </Icon>
                      </MDButton>
                    )}
            </div>
          </div>
        ),
        grnNumber: data.grnNumber,

        ebn: data.ebn,
        totalAsnQty: data.totalAsnQty,
        totalAmount: data.totalAmount,
        isPrinted: data.isPrinted,
      };

      tempAsnDetailsData.push(singleData);
    });

    viewAccess && setState({ ...state, rows: tempAsnDetailsData });
  }, [asnDetailsReducer]);

  const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    let asnDetailsData = asnDetailsDownloadReducer.asnDetails.data
      ? asnDetailsDownloadReducer.asnDetails.data
      : [];

    // setVirtualBinsData(binsData);
    // setPaginationObj(asnDetailsDownloadReducer.asnDetails.pagination);

    // setLoading2(asnDetailsDownloadReducer.loading);
    asnDetailsData.map((data) => {
      // const formatDateForShippedDate = new Date(data.shippedDate);
      const formatDateForCD = new Date(data.cd);
      const singleData = {
        // privateKey: data.asnCode,
        asnCode: data.asnCode,
        asnQty: data.asnQty,

        itemCode: data.itemCode,
        itemDescription: data.itemDescription,
        grnNumber: data.grnNumber,
        invoiceNo: data.invoiceNo,
        invoiceDoc: data.invoiceDoc,
        testCertificate: data.testCertificate,
        packageType: data.packageType,
        status: (
          <h4>
            <button
              className={
                (data.status == "Discrepancy" && `status-error`) ||
                (data.status == "GRN Created" && `status-success`) ||
                (data.status == "Created" && `status-created`) ||
                (data.status == "Loading Pending" && `status-warning`) ||
                (data.status == "Loading Done" && `status-done`) ||
                (data.status == "Shipped" && `status-warning`)
              }
              style={{ width: "5.5rem" }}
            >
              {data.status}
            </button>
          </h4>
        ),
        transporterName: data.transporterName,
        transporterType: data.transporterType,
        lrDocketno: data.lrDocketno,
        vehicleNamePlate: data.vehicleNamePlate,
        phoneNumber: data.phoneNumber,

        cd: data.cd,
        shippedDate: data.shippedDate,

        action: (
          <div>
            <div style={{ display: "flex" }}>
              {updateAccess && (
                <Tooltip title="ASN Update">
                  <MDButton
                    disabled={
                      data.status == "Shipped" ||
                      data.status == "GRN Created" ||
                      data.status == "Discrepancy" ||
                      data.status == "Loading Done"
                    }
                    variant="gradient"
                    color="success"
                    type="button"
                    iconOnly
                    size="small"
                    onClick={() => {
                      setPartCode(data.itemCode);
                      setAsnCode(data.binCode);
                      setDemandId(data.demandId);

                      handleOpenEditASNModal(data);
                    }}
                    style={{ marginRight: "5px", padding: "2%" }}
                  >
                    <Icon style={{ marginRight: "2px" }}>edit</Icon>
                  </MDButton>
                </Tooltip>
              )}

              {viewAccess && (
                <Tooltip title="View">
                  <MDButton
                    variant="gradient"
                    color="info"
                    type="button"
                    onClick={() => {
                      setPartCode(data.itemCode);
                      setAsnCode(data.asnCode);
                      getBinsData(
                        data.asnCode,
                        [],
                        pageNoForBin,
                        rowsPerPageForBin,
                        searchObjectForBin,
                        jwtToken,
                      );
                      setVendorUserId(data.vendorUserId);
                      setBinType(data.isVirtualBin);
                      handleOpenViewASNModal(data);
                    }}
                    iconOnly
                    size="small"
                    style={{ marginRight: "5px", marginBottom: "5px" }}
                  >
                    <Icon> visibility_icon </Icon>
                  </MDButton>
                </Tooltip>
              )}
            </div>

            <div style={{ display: "flex" }}>
              {data.status == "Created" ? (
                updateVehicleDetailsAccess && (
                  <Tooltip title="Confirm Details">
                    <MDButton
                      className={data.status == "Created" && `blink_me`}
                      disabled={
                        data.status == "Shipped" ||
                        data.status == "GRN Created" ||
                        data.status == "Discrepancy"
                      }
                      variant="gradient"
                      color="warning"
                      type="button"
                      onClick={() => {
                        setAsnCode(data.binCode);
                        handleOpenConfirmVehicleDetailsModal(data);
                      }}
                      iconOnly
                      size="small"
                      style={{ marginRight: "5px", marginBottom: "5px" }}
                    >
                      <Icon> local_shipping </Icon>
                    </MDButton>
                  </Tooltip>
                )
              ) : (
                <>
                  {data.status == "Shipped" ||
                  data.status == "GRN Created" ||
                  data.status == "Discrepancy"
                    ? updateVehicleDetailsAccess && (
                        <MDButton
                          // className={data.status == "Loading Pending" && `blink_me`}
                          disabled={
                            data.status == "Shipped" ||
                            data.status == "GRN Created" ||
                            data.status == "Discrepancy"
                          }
                          variant="gradient"
                          color="white"
                          type="button"
                          onClick={() => {
                            setAsnCode(data.binCode);
                            handleOpenConfirmVehicleDetailsModal(data);
                          }}
                          iconOnly
                          size="small"
                          style={{
                            marginRight: "5px",
                            marginBottom: "5px",
                            background: "#BCBCBC",
                            color: "white",
                          }}
                        >
                          <Icon> local_shipping </Icon>
                        </MDButton>
                      )
                    : updateVehicleDetailsAccess && (
                        <Tooltip title="Confirm Details">
                          <MDButton
                            // className={data.status == "Loading Pending" && `blink_me`}
                            disabled={
                              data.status == "Shipped" ||
                              data.status == "GRN Created" ||
                              data.status == "Discrepancy"
                            }
                            variant="gradient"
                            color="warning"
                            type="button"
                            onClick={() => {
                              setAsnCode(data.binCode);
                              handleOpenConfirmVehicleDetailsModal(data);
                            }}
                            iconOnly
                            size="small"
                            style={{ marginRight: "5px", marginBottom: "5px" }}
                          >
                            <Icon> local_shipping </Icon>
                          </MDButton>
                        </Tooltip>
                      )}
                </>
              )}

              {data.status == "Shipped" ||
              data.status == "GRN Created" ||
              data.status == "Discrepancy"
                ? printAsnAccess && (
                    <Tooltip title="Reprint ASN">
                      <MDButton
                        // disabled={data.status !== "Loading Done"}
                        variant="gradient"
                        // color="white"
                        style={{ background: "#0BB9B3", color: "white" }}
                        type="button"
                        onClick={() => {
                          setAsnCode(data.asnCode);
                          setPrintStatus(data.status);
                          // handlePrintAsn();
                          // printAsn(data.asnCode, jwtToken);
                          setPrintAsnDetailsPartCode(data.itemCode);
                          setPrintAsnDetailsPartDescription(
                            data.itemDescription,
                          );
                          setPrintAsnDetailsGrnNumber(data.grnNumber);
                          setPrintAsnDetailsLRNumber(data.lrDocketNo);
                          setPrintAsnDetailsTransporterName(
                            data.transporterName,
                          );
                          setPrintAsnDetailsTransporterType(
                            data.transporterType,
                          );
                          setPrintAsnDetailsVehicleNameplate(
                            data.vehicleNamePlate,
                          );
                          setPrintAsnDetailsPhoneNumber(data.phoneNumber);
                          setPrintAsnDetailsPurchaseOrderNumber(data.poNumber);
                          setPrintAsnDetailsPurchaseOrderLineNumber(
                            data.poLineNumber,
                          );
                          setPrintAsnDetailsInvoiceNo(data.invoiceNo);
                          setPrintAsnDetailsVendorCode(data.vendorCode);
                          setPrintAsnDetailsVendorName(data.vendorName);
                          setPrintAsnDetailsShippedDate(data.shippedDate);
                          setPrintAsnDetailsCreatedDate(data.cd);
                          setPrintAsnDetailsAsnQty(data.asnQty);
                          setPrintAsnDetailsPacketQty(data.packetQty);
                          setPrintAsnDetailsPacketWeight(data.packetWeight);
                          setPrintAsnDetailsInvoiceDate(data.invoiceDate);
                          handleOpenPrintASNModal(data);
                        }}
                        size="small"
                        iconOnly
                        // style={{ padding: "2%", width: "100px" }}
                      >
                        {/* Print ASN */}
                        <Icon> print </Icon>
                      </MDButton>
                    </Tooltip>
                  )
                : data.status == "Loading Done"
                  ? printAsnAccess && (
                      <Tooltip title="Print ASN">
                        <MDButton
                          disabled={data.status !== "Loading Done"}
                          className={
                            data.status == "Loading Done" && `blink_me`
                          }
                          variant="gradient"
                          style={{ background: "#0BB9B3", color: "white" }}
                          type="button"
                          onClick={() => {
                            setAsnCode(data.asnCode);
                            // handlePrintAsn();
                            printAsn(data.asnCode, jwtToken);
                            setPrintAsnDetailsPartCode(data.itemCode);
                            setPrintAsnDetailsPartDescription(
                              data.itemDescription,
                            );
                            setPrintAsnDetailsGrnNumber(data.grnNumber);
                            setPrintAsnDetailsLRNumber(data.lrDocketNo);
                            setPrintAsnDetailsTransporterName(
                              data.transporterName,
                            );
                            setPrintAsnDetailsTransporterType(
                              data.transporterType,
                            );
                            setPrintAsnDetailsVehicleNameplate(
                              data.vehicleNamePlate,
                            );
                            setPrintAsnDetailsPhoneNumber(data.phoneNumber);
                            setPrintAsnDetailsPurchaseOrderNumber(
                              data.poNumber,
                            );
                            setPrintAsnDetailsPurchaseOrderLineNumber(
                              data.poLineNumber,
                            );
                            setPrintAsnDetailsInvoiceNo(data.invoiceNo);
                            setPrintAsnDetailsVendorCode(data.vendorCode);
                            setPrintAsnDetailsVendorName(data.vendorName);
                            setPrintAsnDetailsShippedDate(data.shippedDate);
                            setPrintAsnDetailsCreatedDate(data.cd);
                            setPrintAsnDetailsAsnQty(data.asnQty);
                            setPrintAsnDetailsPacketQty(data.packetQty);
                            setPrintAsnDetailsPacketWeight(data.packetWeight);
                            setPrintAsnDetailsInvoiceDate(data.invoiceDate);
                            handleOpenPrintASNModal(data);
                          }}
                          iconOnly
                          size="small"
                          // style={{ padding: "2%", width: "100px" }}
                        >
                          {/* Print ASN */}
                          <Icon> print </Icon>
                        </MDButton>
                      </Tooltip>
                    )
                  : printAsnAccess && (
                      <MDButton
                        disabled={data.status !== "Loading Done"}
                        className={data.status == "Loading Done" && `blink_me`}
                        variant="gradient"
                        style={{ background: "#BCBCBC", color: "white" }}
                        type="button"
                        iconOnly
                      >
                        <Icon> print </Icon>
                      </MDButton>
                    )}
            </div>
          </div>
        ),
        grnNumber: data.grnNumber,

        ebn: data.ebn,
        totalAsnQty: data.totalAsnQty,
        totalAmount: data.totalAmount,
        isPrinted: data.isPrinted,
      };

      tempAsnDetailsData.push(singleData);
    });

    setDownloadData(tempAsnDetailsData);
  }, [asnDetailsDownloadReducer]);

  useEffect(() => {
    let tempBins = [];
    let data = binsForPrintReducer.binsForPrintData.data
      ? binsForPrintReducer.binsForPrintData.data
      : [];

    setPrintData(data);
  }, [binsForPrintReducer]);

  let tempBinsData = [];

  useEffect(() => {
    let binsData = binsReducer.bins.data ? binsReducer.bins.data : [];

    setVirtualBinsData(binsData);
    setPaginationObjForBin(binsReducer.bins.pagination);
    binsData.map((data) => {
      // const formatDateForShippedDate = new Date(data.shippedDate);

      const singleData = {
        privateKey: data.binCode,
        binCode: data.binCode,
        qty: data.qty,
        status:
          data.isVerified === true ? (
            <Tooltip title="Verified">
              <Icon
                color="success"
                size="large"
                style={{ marginRight: "2px", fontSize: "15px" }}
              >
                check_circle
              </Icon>
            </Tooltip>
          ) : (
            <Tooltip title="Not Verified">
              <Icon
                color="error"
                size="large"
                style={{ marginRight: "2px", fontSize: "15px" }}
              >
                check_circle
              </Icon>
            </Tooltip>
          ),
        receivedQty: data.receivedQty,
        // abc: data.isVerified === true && setYY(data),
        verify:
          (!data.isVerified && data.status === "Loading Pending") ||
          (!data.isVerified && data.status === "Created") ? (
            <Tooltip title="Verify">
              <MDButton
                variant="gradient"
                color="success"
                type="button"
                iconOnly
                size="small"
                onClick={() => {
                  setPartCode(data.itemCode);
                  // setAsnCode(data.asnCode);
                  setDemandId(data.demandId);

                  handleOpenUpdateCNFQTYModal(data);
                }}
                style={{ marginRight: "5px", padding: "2%" }}
              >
                <Icon style={{ marginRight: "2px" }}>edit</Icon>
              </MDButton>
            </Tooltip>
          ) : (
            <Tooltip title="Verified">
              <MDButton
                disabled
                variant="gradient"
                color="success"
                type="button"
                iconOnly
                size="small"
                style={{ marginRight: "5px", padding: "2%" }}
              >
                <Icon style={{ marginRight: "2px" }}>edit</Icon>
              </MDButton>
            </Tooltip>
          ),
      };

      tempBinsData.push(singleData);
    });

    binType === 1
      ? setVirtualBinsTable({ ...virtualBinsTable, rows: tempBinsData })
      : setBinsTable({ ...binsTable, rows: tempBinsData });
  }, [binsReducer]);

  const [flag, setFlag] = useState(false);
  const [lastAsnSingleData, setLastAsnSingleData] = useState("");

  const [printAsnDetailsPartCode, setPrintAsnDetailsPartCode] = useState("");
  const [printAsnDetailsInvoiceNo, setPrintAsnDetailsInvoiceNo] = useState("");
  const [printAsnDetailsTransporterName, setPrintAsnDetailsTransporterName] =
    useState("");
  const [printAsnDetailsVehicleNameplate, setPrintAsnDetailsVehicleNameplate] =
    useState("");
  const [printAsnDetailsTransporterType, setPrintAsnDetailsTransporterType] =
    useState("");
  const [printAsnDetailsLRNumber, setPrintAsnDetailsLRNumber] = useState("");
  const [printAsnDetailsPhoneNumber, setPrintAsnDetailsPhoneNumber] =
    useState("");
  const [
    printAsnDetailsPurchaseOrderNumber,
    setPrintAsnDetailsPurchaseOrderNumber,
  ] = useState("");
  const [
    printAsnDetailsPurchaseOrderLineNumber,
    setPrintAsnDetailsPurchaseOrderLineNumber,
  ] = useState("");

  const [printAsnDetailsPartDescription, setPrintAsnDetailsPartDescription] =
    useState("");
  const [printAsnDetailsAsnQty, setPrintAsnDetailsAsnQty] = useState("");
  const [printAsnDetailsGrnNumber, setPrintAsnDetailsGrnNumber] = useState("");
  const [printAsnDetailsInvoiceDate, setPrintAsnDetailsInvoiceDate] =
    useState("");
  const [printAsnDetailsPacketQty, setPrintAsnDetailsPacketQty] = useState("");
  const [printAsnDetailsPacketWeight, setPrintAsnDetailsPacketWeight] =
    useState("");
  const [printAsnDetailsShippedDate, setPrintAsnDetailsShippedDate] =
    useState("");

  const [printAsnDetailsCreatedDate, setPrintAsnDetailsCreatedDate] =
    useState("");
  const [printAsnDetailsVendorCode, setPrintAsnDetailsVendorCode] =
    useState("");
  const [printAsnDetailsVendorName, setPrintAsnDetailsVendorName] =
    useState("");

  const handleLastAsnData = () => {
    getLastAsnDetails(email, jwtToken);
    setLastAsnSingleData(lastAsnData);
    setFlag(true);
  };

  let lastAsnData = lastAsnDetailsReducer.lastAsnDetails.data
    ? lastAsnDetailsReducer.lastAsnDetails.data[0]
    : [];

  // useEffect(() => {
  //   getAsnItemsDetails(asnId);
  // }, [asnId]);

  // useEffect(() => {
  //   let tempAsnItemsDetailsData = [];
  //   let data = asnItemsDetailsReducer.asnItemsDetails.data
  //     ? asnItemsDetailsReducer.asnItemsDetails.data
  //     : [];

  //   data.map((data) => {
  //     const asnItemlistObject = {
  //       privateKey: data.itemId,
  //       orderNumber: data.orderNumber,

  //       totalAmount: data.totalAmount,

  //       lineItemNumber: data.lineItemNumber,
  //       itemCode: data.itemCode,
  //       item: data.item,
  //       itemQty: data.itemQty,
  //       asnQty: data.asnQty,

  //       // remainingQty: data.remainingQty,
  //       amount: data.amount,
  //       receivingDate: data.receivingDate,
  //     };
  //     tempAsnItemsDetailsData.push(asnItemlistObject);
  //   });
  //   setListOfItemsState({ ...listOfItemsState, rows: tempAsnItemsDetailsData });
  // }, [asnItemsDetailsReducer]);

  // const clickHandler = () => {
  //   navigate("/purchase-orders");
  // };

  // const confirmVehicleDetailsAlertNotification = () =>
  // toast.warning('🦄 Wow so easy!', {
  //   position: "top-right",
  //   autoClose: false,
  //   hideProgressBar: false,
  //   closeOnClick: false,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   theme: "colored",
  //   });

  // useEffect(() => {
  //   confirmVehicleDetailsAlertNotification();
  // }, [third])

  const confirmVehicleDetailsNotification = () =>
    toast.success("Vehicle Details Submitted Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const virtualBinUpdateNotification = () =>
    toast.success("Virtual Bins Confirmed Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [isErrorAcceptPo, setIsErrorAcceptPo] = useState(false);

  useEffect(() => {
    if (isErrorAcceptPo) {
      setTimeout(() => {
        setIsErrorAcceptPo(false);
      }, 3000);
    }
  }, [isErrorAcceptPo]);

  const asnPrintNotification = () =>
    toast.success("ASN Printed Successfully", {
      position: "top-center",
    });

  // const printQRHandler = async () => {
  //   let payload = {
  //     asnCode: singleDataForPrintQRModal.asnCode,
  //     totalAmount: singleDataForPrintQRModal.totalAmount,
  //     receivingDate: singleDataForPrintQRModal.receivingDate,
  //     ebn: singleDataForPrintQRModal.ebn,
  //     // isPrinted: singleDataForPrintQRModal.isPrinted
  //   };

  //   let response = await createPrintQR(payload);

  //   if (response.status) {
  //     handleClosePrintQRModal();

  //     setTimeout(() => {
  //       getAsnDetails(emailId);
  //     }, 0);

  //     acceptedPoNotification();
  //   }
  //   if (response.status == false) {
  //     setIsErrorAcceptPo(true);
  //   }
  // };

  const [openConfirmASNModal, setOpenConfirmASNModal] = useState(false);

  const handleOpenConfirmASNModal = () => {
    setOpenConfirmASNModal(!openConfirmASNModal);
  };

  const [openViewASNModal, setOpenViewASNModal] = useState(false);

  const [singleASNData, setSingleASNData] = useState({});
  const handleOpenViewASNModal = (asnData = {}) => {
    setSingleASNData(asnData);
    setOpenViewASNModal(true);
    // getBinsData(asnCode, [], pageNo, rowsPerPage, searchObject, jwtToken);
    // cookies.set("detailsForVirtualBin", JSON.stringify([]), {
    //   path: "/",
    // });
    localStorage.setItem("detailsForVirtualBin", JSON.stringify([]));
  };
  const handleCloseViewASNModal = () => {
    setOpenViewASNModal(false);
    localStorage.removeItem("detailsForVirtualBin");
    // formikForUpdate.setErrors({});
  };

  const [document, setDocument] = useState("");

  const [openPrintASNModal, setOpenPrintASNModal] = useState(false);
  const handleOpenPrintASNModal = (data = {}) => {
    setDocument(data.url);
    setOpenPrintASNModal(true);
  };
  const handleClosePrintASNModal = () => {
    setOpenPrintASNModal(false);
    getAsnDetails(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected
        : [{ email: email }],
      statusSelected ? statusSelected.value : "",
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  };

  const [isErrorConfirmVehicleDetails, setIsErrorConfirmVehicleDetails] =
    useState(false);
  const [isSuccessConfirmVehicleDetails, setIsSuccessConfirmVehicleDetails] =
    useState(false);

  useEffect(() => {
    if (isErrorConfirmVehicleDetails) {
      setTimeout(() => {
        setIsErrorConfirmVehicleDetails(false);
      }, 3000);
    }
  }, [isErrorConfirmVehicleDetails]);

  useEffect(() => {
    if (isSuccessConfirmVehicleDetails) {
      setTimeout(() => {
        setIsSuccessConfirmVehicleDetails(false);
      }, 3000);
    }
  }, [isSuccessConfirmVehicleDetails]);

  const [openConfirmVehicleDetailsModal, setOpenConfirmVehicleDetailsModal] =
    useState(false);

  const handleOpenConfirmVehicleDetailsModal = (data = {}) => {
    setSingleASNData(data);
    setOpenConfirmVehicleDetailsModal(true);
    setIsErrorConfirmVehicleDetails(false);
    setIsSuccessConfirmVehicleDetails(false);
  };
  const handleCloseConfirmVehicleDetailsModal = () => {
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
    setOpenConfirmVehicleDetailsModal(false);
    setFlag(false);
    setLastAsnSingleData("");
    getAsnDetails(
      [{ email: email }],
      statusSelected ? statusSelected.value : "",
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  };

  const initialValues = {
    asnCode: singleASNData ? singleASNData.asnCode : "",
    invoiceNo: singleASNData ? singleASNData.invoiceNo : "",
    itemCode: singleASNData ? singleASNData.itemCode : "",

    transporterName: lastAsnData ? lastAsnData.transporterName : "",
    transporterType: lastAsnData ? lastAsnData.transporterType : "",
    vehicleNamePlate: lastAsnData ? lastAsnData.vehicleNamePlate : "",
    phoneNumber: lastAsnData ? lastAsnData.phoneNumber : "",
    lrDocketNo: lastAsnData ? lastAsnData.lrDocketNo : "",
  };

  const validationSchema = Yup.object({
    transporterName: Yup.string().required("Enter Transporter Name"),
    transporterType: Yup.string().required("Enter Transporter Type"),
    vehicleNamePlate: Yup.string().required("Enter Vehicle NamePlate"),
    phoneNumber: Yup.number()
      .positive("Please enter a positive number")
      .min(1000000000, "Invalid Phone Number")
      .max(9999999999, "Invalid Phone Number")
      .required("Enter a valid Phone Number"),
    lrDocketNo: Yup.string().required("Enter LR Docket No"),
  });

  const onSubmit = async (values, { resetForm }) => {
    let payload = {
      asnCode: values.asnCode,
      transporterName: values.transporterName,
      transporterType: values.transporterType,
      vehicleNamePlate: values.vehicleNamePlate,
      phoneNumber: values.phoneNumber,
      lrDocketNo: values.lrDocketNo,
    };

    let response = await updateVehicleDetails(payload, jwtToken);
    if (response.status === true) {
      setIsSuccessConfirmVehicleDetails(true);
      confirmVehicleDetailsNotification();
      handleCloseConfirmVehicleDetailsModal();

      getAsnDetails(
        [{ email: email }],
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );

      resetForm();
    }
    if (response.status === false) {
      setIsErrorConfirmVehicleDetails(true);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  const handlePrintAsn = async () => {
    let payload = {
      asnCode: asnCode,
    };

    const res = await printAsn(payload, jwtToken);

    // const res = await createProductionOrder(payload);

    if (res.status) {
      asnPrintNotification();
      setOpenPrintASNModal(false);
      getAsnDetails(
        [{ email: email }],
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      // setOpenBomItemModal(!bomItemModal);
    }
    // if (!res.status) {
    //   setIsErrorCreateOrder(true);
    // }
  };

  const AsnUpdatedNotification = () =>
    toast.success("Asn Updated Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [openEditASNModal, setOpenEditASNModal] = useState(false);

  const handleCloseEditASNModal = () => {
    setOpenEditASNModal(false);
    setSingleASNDataForEdit({});
    setAsnQtyChange("");
    setSingleAsnPackageWeightData("");
    setSingleAsnPackageDetailsData({});

    formikForEdit.setValues(initialValuesForEditAsn);
    formikForEdit.setTouched({});
    formikForEdit.setErrors({});
  };

  const AsnCreationNotification = () =>
    toast.success("Asn Updated Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [isErrorEditASN, setIsErrorEditASN] = useState(false);
  const [isSuccessEditASN, setIsSuccessEditASN] = useState(false);

  useEffect(() => {
    if (isErrorEditASN) {
      setTimeout(() => {
        setIsErrorEditASN(false);
      }, 3000);
    }
  }, [isErrorEditASN]);

  useEffect(() => {
    if (isSuccessEditASN) {
      setTimeout(() => {
        setIsSuccessEditASN(false);
      }, 3000);
    }
  }, [isSuccessEditASN]);

  const initialValuesForEditAsn = {
    demandId: singleASNDataForEdit ? singleASNDataForEdit.demandId : "",
    partNoDes: `${singleASNDataForEdit?.itemCode}/${singleASNDataForEdit?.itemDescription}`,
    poNoLineNo: `${singleASNDataForEdit ? singleASNDataForEdit.poNumber : ""}/${
      singleASNDataForEdit ? singleASNDataForEdit.poLineNumber : ""
    }`,
    scheduleQuantity: singleASNDataForEdit
      ? singleASNDataForEdit.scheduleQty
      : "",
    asnQty: asnQtyChange ? asnQtyChange : "",
    balanceQty: asnQtyChange
      ? singleASNDataForEdit.balanceQty +
        singleASNDataForEdit.asnQty -
        asnQtyChange
      : singleASNDataForEdit.balanceQty,
    unloadingPoint: singleUnloadingPointData ? singleUnloadingPointData : "",
    deliveryPlant: singleDeliveryPlantData ? singleDeliveryPlantData : "",
    packageType: singleAsnPackageTypeData ? singleAsnPackageTypeData : "",
    packetNo: singleAsnPackageDetailsData
      ? singleAsnPackageDetailsData.packetQty
      : singleASNDataForEdit.packetQty,
    unitPackQty: singleAsnPackageDetailsData
      ? singleAsnPackageDetailsData.unitPackQty
      : singleASNDataForEdit.unitPackQty,

    packetWeight: singleAsnPackageWeightData ? singleAsnPackageWeightData : "",
    invoiceNo: singleASNDataForEdit ? singleASNDataForEdit.invoiceNo : "",
    invoiceDate: singleASNDataForEdit ? singleASNDataForEdit.invoiceDate : "",
    // invoiceFile: "",
    planDate: "",
  };

  const validationSchemaForEdit = Yup.object({
    asnQty: Yup.number()
      .min(1)
      .max(
        singleASNDataForEdit.balanceQty !== 0
          ? singleASNDataForEdit.balanceQty
          : singleASNDataForEdit.asnQty,
      )
      .required("Enter ASN Quantity"),
    invoiceNo: Yup.string().required("Enter Invoice No"),
    invoiceDate: Yup.string().required("Enter Invoice Date"),
  });

  const onSubmitForEdit = async (values, { resetForm }) => {
    let payload = {
      testCertificate: fileForTestCertificate,
      invoice: fileForInvoiceFile,
      invoiceNo: values.invoiceNo,
      invoiceDate: values.invoiceDate,
      planDate: singleASNDataForEdit ? singleASNDataForEdit.planDate : "",
      partNoDes: values.partNoDes,
      poNoLineNo: values.poNoLineNo,
      asnCode: singleASNDataForEdit?.asnCode,
      asnQty: asnQtyChange,
      packageType: singleAsnPackageTypeData,
      packetNo: singleAsnPackageDetailsData.packetQty,
      packetWeight: singleAsnPackageWeightData,
      unloadingPoint: singleASNDataForEdit.unloadingPoint,
      deliveryPlant: singleASNDataForEdit.deliveryPlant,
      // demandId: singleASNData ? singleASNData.id : "",
      vendorId: userId,
    };

    let response = await updateAsn(payload, jwtToken);
    // setTimeout(() => {

    //   AsnUpdatedNotification();
    //   handleCloseEditASNModal();
    // }, 1000);

    if (response.status === true) {
      setAsnCode(response.data.data.asnCode);
      // setPackageType(response.data.data.packageType);
      // AsnCreationNotification();
      setIsSuccessEditASN(true);
      AsnUpdatedNotification();
      setOpenEditASNModal(false);
      handleCloseEditASNModal();
      getAsnDetails(
        [{ email: email }],
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      resetForm();
    }
    if (response.status === false) {
      setIsErrorEditASN(true);
    }
  };

  const formikForEdit = useFormik({
    initialValues: initialValuesForEditAsn,
    onSubmit: onSubmitForEdit,
    validationSchema: validationSchemaForEdit,
    enableReinitialize: true,
  });

  const [openPrintMultipleBinsOfASNModal, setOpenPrintMultipleBinsOfASNModal] =
    useState(false);

  const handleClosePrintMultipleBinsOfASNModal = () => {
    setOpenPrintMultipleBinsOfASNModal(false);
  };

  const handleOpenPrintMultipleBinsOfASNModal = () => {
    setOpenPrintMultipleBinsOfASNModal(true);
  };

  const [selectedConfirmVirtualBinsData, setSelectedConfirmVirtualBinsData] =
    useState([]);

  const [validationErrorMsg, setValidationErrorMsg] = useState("");

  useEffect(() => {
    setValidationErrorMsg("");
  }, [selectedConfirmVirtualBinsData]);

  const [resourceCategoryValidation, setResourceCategoryValidation] =
    useState(false);

  const [uncheck, setUncheck] = useState(false);
  const [binvalue, setbinvalue] = useState("");

  const [disableButton, setDisableButton] = useState(false);
  const [disableButton2, setDisableButton2] = useState(false);
  useEffect(() => {
    let value = virtualBinsData.some((data) => data.isVerified == false);

    setDisableButton(value);
  }, [virtualBinsData]);

  useEffect(() => {
    let value = virtualBinsData.some((data) => data.isConfirmed == true);

    setDisableButton2(value);
  }, [virtualBinsData]);

  const pivDataSelectionHandler = (data) => {
    setSelectedConfirmVirtualBinsData(data);
  };

  const [isErrorConfirmVirtualBins, setIsErrorConfirmVirtualBins] =
    useState(false);
  const [isSuccessConfirmVirtualBins, setIsSuccessConfirmVirtualBins] =
    useState(false);

  useEffect(() => {
    if (isErrorConfirmVirtualBins) {
      setTimeout(() => {
        setIsErrorConfirmVirtualBins(false);
      }, 3000);
    }
  }, [isErrorConfirmVirtualBins]);

  useEffect(() => {
    if (isSuccessConfirmVirtualBins) {
      setTimeout(() => {
        setIsSuccessConfirmVirtualBins(false);
      }, 3000);
    }
  }, [isSuccessConfirmVirtualBins]);

  const [verificationStatus, setVerificationStatus] = useState(false);

  const [openEditFromLocModal, setOpenEditFromLocModal] = useState(false);

  const handleOpenEditFromLocModal = () => {
    setOpenEditFromLocModal(true);
  };

  const handleCloseEditFromLocModal = () => {
    setOpenEditFromLocModal(false);
  };

  const [resourceSelected, setResourceSelected] = useState("");
  const handleResourceChange = (selectedResource) => {
    setResourceSelected(selectedResource);
  };

  const [openConfirmVirtualBinsModal, setOpenConfirmVirtualBinsModal] =
    useState(false);

  const handleOpenConfirmVirtualBinsModal = () => {
    setOpenConfirmVirtualBinsModal(true);
  };

  const handleCloseConfirmVirtualBinsModal = () => {
    setOpenConfirmVirtualBinsModal(false);
  };

  const releaseValidationHandler = async (values) => {
    let finalPayload = {
      asnCode: asnCode,
      bins: virtual,
    };

    let res = await confirmVirtualBins(finalPayload, jwtToken);

    if (res.status) {
      setIsSuccessConfirmVirtualBins(true);
      virtualBinUpdateNotification();
      handleCloseViewASNModal();
      getAsnDetails(
        [{ email: email }],
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );

      // resetForm();

      setTimeout(() => {
        handleCloseConfirmVirtualBinsModal();
      }, 2250);
    }
    if (!res.status) {
      setValidationErrorMsg("Could not confirm");
    }
  };

  const [openUpdateCNFQTYModal, setOpenUpdateCNFQTYModal] = useState(false);
  const [
    singleMonthlyDemandDataForUpdate,
    setSingleMonthlyDemandDataForUpdate,
  ] = useState({});
  const handleOpenUpdateCNFQTYModal = (CNFQTY = {}) => {
    setSingleMonthlyDemandDataForUpdate(CNFQTY);
    setOpenUpdateCNFQTYModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateCNFQTYModal = () => {
    setOpenUpdateCNFQTYModal(false);
    formikForVerify.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  // let virtual = cookies.get("detailsForVirtualBin");
  let virtual = JSON.parse(localStorage.getItem("detailsForVirtualBin"));

  const initialValueForUpdate = {
    // departmentId: singleDepartmentDataForUpdate.departmentId,

    remark: singleMonthlyDemandDataForUpdate.remark,
  };

  const validationSchemaForUpdate = Yup.object({
    // remark: Yup.string().required("Enter a valid remark"),
  });

  const onSubmitForUpdate = async (values) => {
    let payload = [];

    let payload2 = {
      asnCode: asnCode,
      bins: virtual,
    };

    if (values.remark === singleMonthlyDemandDataForUpdate.binCode) {
      // let finalVirtualBin = {values.remark}

      const tempPayload = {
        binCode: values.remark,
      };

      virtual.push(tempPayload);
      // cookies.set("detailsForVirtualBin", JSON.stringify(virtual), {
      //   path: "/",
      // });

      localStorage.setItem("detailsForVirtualBin", JSON.stringify(virtual));

      // payload.push({
      //   binCode : values.remark
      // })
      getBinsData(
        asnCode,
        virtual,
        pageNoForBin,
        rowsPerPageForBin,
        searchObjectForBin,
        jwtToken,
      );

      setTimeout(() => {
        handleCloseUpdateCNFQTYModal();
      }, 2000);

      setIsSuccessForUpdate(true);
      setVerificationStatus(true);
    } else {
      setIsErrorForUpdate(true);
    }
  };

  const formikForVerify = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    // enableReinitialize: true,
  });

  const [asnDocumentName, setAsnDocumentName] = useState("");
  const [asnDocument, setAsnDocument] = useState("");
  useEffect(() => {
    let data = postCertificateViewReducer.viewDocument.data
      ? postCertificateViewReducer.viewDocument.data
      : [];

    setAsnDocument(data);
  }, [postCertificateViewReducer]);
  const [openViewDocumentModal, setOpenViewDocumentModal] = useState(false);

  const handleOpenViewDocumentModal = (data) => {
    // setAsnDocument(data);
    setOpenViewDocumentModal(true);
  };

  const handleCloseViewDocumentModal = () => {
    setOpenViewDocumentModal(false);
  };

  const headers = [
    {
      label: "asnCode",
      key: "asnCode",
    },
    {
      label: "asnQty",
      key: "asnQty",
    },
    {
      label: "partCode",
      key: "partCode",
    },
    {
      label: "grnNumber",
      key: "grnNumber",
    },
    {
      label: "invoiceNo",
      key: "invoiceNo",
    },
    {
      label: "createdDate",
      key: "cd",
    },
    {
      label: "shippedDate",
      key: "shippedDate",
    },
  ];

  const csvLink = {
    filename: "Asn List.csv",
    headers: headers,
    data: downloadData,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading2]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getAsnDetails(
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected
          : [{ email: email }],
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-4}
                mt={-4}
              >
                <MDBox display="flex" marginTop="30px" flexGrow={1}>
                  {roleName !== "vendor" && (
                    <MDBox style={{ width: "400px", marginRight: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Vendors
                      </MDTypography>
                      <Select
                        isMulti
                        isClearable
                        placeholder="Vendors"
                        className="select-css-for-filter"
                        value={vendorsListForPlannerSelected}
                        options={vendorsListForPlannerOptions}
                        onChange={handleChangeVendorsListForPlanner}
                        autoComplete="off"
                      />
                    </MDBox>
                  )}
                  <MDBox style={{ width: "300px", marginRight: "10px" }}>
                    <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                      Status
                    </MDTypography>
                    <Select
                      isClearable
                      placeholder="All Status"
                      className="select-css-for-filter"
                      value={statusSelected}
                      options={statusOptions}
                      onChange={handleChangeStatus}
                      autoComplete="off"
                      maxMenuHeight={130}
                    />
                  </MDBox>

                  <MDBox display="flex" marginLeft="auto">
                    {downloadAccess && (
                      <CSVLink {...csvLink}>
                        <Tooltip title="Download Asn List">
                          <MDButton
                            style={{
                              display: "flex",
                              position: "relative",
                              marginLeft: "auto",
                              float: "right",
                            }}
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            size="small"
                            title="Download Asn List"
                          >
                            <Icon>download</Icon>
                          </MDButton>
                        </Tooltip>
                      </CSVLink>
                    )}
                  </MDBox>
                </MDBox>
              </MDBox>

              <MDBox pt={1}>
                {/* {role === "user" ? ( */}
                <>
                  {/* {!loading ? ( */}
                  {/* <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      tableSearch={true}
                      options={{ draggable: false }}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      totalRecords={rows?.length}
                      showTotalEntries={true}
                      noEndBorder
                    /> */}
                  <DataTable
                    table={{ columns, rows }}
                    isSorted
                    tableSearch
                    showTotalEntries
                    noEndBorder
                    loading={loading2}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    serverSidePagination
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    options={{ draggable: false }}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                  {/* ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )} */}
                </>
                {/* ) : null} */}
              </MDBox>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openViewASNModal}
                onClose={handleCloseViewASNModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForModal}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      View ASN
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseViewASNModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox pb={3} px={1} overflow="auto" height="500px">
                    <MDBox pt={1} px={1}>
                      <MDBox
                        component="form"
                        role="form"
                        // onSubmit={formik.handleSubmit}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} lg={4}>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Vendor Code
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.vendorCode}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Vendor Name
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.vendorName}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                ASN No
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.asnCode}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                ASN Qty
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.asnQty}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice No
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.invoiceNo}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Phone Number
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="phoneNumber"
                                fullWidth
                                value={singleASNData.phoneNumber}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 10,
                                }}
                              />
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice Date
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData?.invoiceDate?.slice(0, 10)}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Part No
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.itemCode}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                GRN No
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.grnNumber}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                GRN Qty
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.grnQty}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Created Date
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.cd}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice
                              </MDTypography>
                              <MDButton
                                type="button"
                                color="info"
                                onClick={() => {
                                  postCertificateView(
                                    singleASNData?.invoiceDoc,
                                    singleASNData?.asnCode,
                                    vendorUserId,
                                    jwtToken,
                                  );
                                  handleOpenViewDocumentModal();
                                  setAsnDocumentName("Invoice");
                                }}
                              >
                                VIEW
                              </MDButton>
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Transporter Type
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.transporterType}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Transporter Name
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.transporterName}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Vehicle Nameplate
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.vehicleNamePlate}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                LR Number
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="lrDocketNo"
                                fullWidth
                                value={singleASNData.lrDocketNo}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Shipped Date
                              </MDTypography>
                              <MDInput
                                type="text"
                                fullWidth
                                value={singleASNData.shippedDate}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={1} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Test Certificate
                              </MDTypography>

                              <MDButton
                                type="button"
                                color="info"
                                onClick={() => {
                                  postCertificateView(
                                    singleASNData?.testCertificate,
                                    singleASNData?.asnCode,
                                    vendorUserId,
                                    jwtToken,
                                  );
                                  handleOpenViewDocumentModal();
                                  setAsnDocumentName("Test Certificate");
                                }}
                              >
                                VIEW
                              </MDButton>
                            </MDBox>

                            <MDBox
                              style={{
                                display: "flex",
                                float: "right",
                                marginTop: "10px",
                              }}
                            >
                              <MDButton
                                color="success"
                                type="button"
                                marginLeft="20px"
                                onClick={handleOpenPrintMultipleBinsOfASNModal}
                                disabled={
                                  !(
                                    /Can/i.test(singleAsnPackageTypeData) ||
                                    /Carton/i.test(singleAsnPackageTypeData) ||
                                    /Corrugated/i.test(singleAsnPackageTypeData)
                                  )
                                }
                              >
                                Reprint PKT QTY
                              </MDButton>
                            </MDBox>
                          </Grid>
                        </Grid>

                        <MDBox pt={-1} overflow="auto" maxHight="90%">
                          {binType === 1 && (
                            <Tooltip title="Confirm">
                              <MDButton
                                disabled={disableButton || disableButton2}
                                color="white"
                                type="button"
                                style={{
                                  width: "10rem",
                                  marginTop: "0.5rem",
                                  color: "white",
                                  border: "1px solid #0275d8",
                                  background: "#0275d8",
                                  // marginLeft: 5,
                                }}
                                onClick={() => {
                                  releaseValidationHandler();
                                }}
                              >
                                Confirm
                              </MDButton>
                            </Tooltip>
                          )}
                          {/* {role === "user" ? ( */}
                          <>
                            <MDBox>
                              <DataTable
                                table={{ columns: binsColumns, rows: binsRows }}
                                isSorted={true}
                                showTotalEntries={true}
                                noEndBorder
                                serverSidePagination={true}
                                paginationObj={paginationObjForBin}
                                pageNoValue={pageNoForBin}
                                rowsPerPageValue={rowsPerPageForBin}
                                pageNoProp={importPageNoForBin}
                                rowsPerPageProp={importRowsPerPageForBin}
                                searchProp={importSearchForBin}
                              />
                            </MDBox>
                          </>

                          {/* ) : null} */}
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openConfirmVehicleDetailsModal}
                onClose={handleCloseConfirmVehicleDetailsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForConfirmModal}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Confirm Details
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseConfirmVehicleDetailsModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox pb={3} px={1} height="500px" overflow="auto">
                    <MDBox pt={1} px={1}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formik.handleSubmit}
                      >
                        <Grid container spacing={4}>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                ASN No
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="asnCode"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.asnCode}
                                error={
                                  formik.touched.asnCode &&
                                  formik.errors.asnCode &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.asnCode &&
                                formik.errors.asnCode && (
                                  <TextError msg={formik.errors.asnCode} />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice No{" "}
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="invoiceNo"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.invoiceNo}
                                error={
                                  formik.touched.invoiceNo &&
                                  formik.errors.invoiceNo &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "14px",
                                  },
                                  // readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.invoiceNo &&
                                formik.errors.invoiceNo && (
                                  <TextError msg={formik.errors.invoiceNo} />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Part No{" "}
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="itemCode"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.itemCode}
                                error={
                                  formik.touched.itemCode &&
                                  formik.errors.itemCode &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.itemCode &&
                                formik.errors.itemCode && (
                                  <TextError msg={formik.errors.itemCode} />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Transporter Type{" "}
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="transporterType"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.transporterType}
                                error={
                                  formik.touched.transporterType &&
                                  formik.errors.transporterType &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.transporterType &&
                                formik.errors.transporterType && (
                                  <TextError
                                    msg={formik.errors.transporterType}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Transporter Name
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="transporterName"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.transporterName}
                                error={
                                  formik.touched.transporterName &&
                                  formik.errors.transporterName &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.transporterName &&
                                formik.errors.transporterName && (
                                  <TextError
                                    msg={formik.errors.transporterName}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Vehicle NamePlate{" "}
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="vehicleNamePlate"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.vehicleNamePlate}
                                error={
                                  formik.touched.vehicleNamePlate &&
                                  formik.errors.vehicleNamePlate &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.vehicleNamePlate &&
                                formik.errors.vehicleNamePlate && (
                                  <TextError
                                    msg={formik.errors.vehicleNamePlate}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                LR Number{" "}
                              </MDTypography>

                              <MDInput
                                type="text"
                                name="lrDocketNo"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.lrDocketNo}
                                error={
                                  formik.touched.lrDocketNo &&
                                  formik.errors.lrDocketNo &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.lrDocketNo &&
                                formik.errors.lrDocketNo && (
                                  <TextError msg={formik.errors.lrDocketNo} />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={1} mt={1}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Phone Number{" "}
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="phoneNumber"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.phoneNumber}
                                error={
                                  formik.touched.phoneNumber &&
                                  formik.errors.phoneNumber &&
                                  true
                                }
                                inputProps={{
                                  maxLength: 10,
                                  style: {
                                    height: "13px",
                                  },
                                }}
                              />
                              {formik.touched.phoneNumber &&
                                formik.errors.phoneNumber && (
                                  <TextError msg={formik.errors.phoneNumber} />
                                )}
                            </MDBox>
                          </Grid>
                        </Grid>

                        <MDBox>
                          <Collapse in={isErrorConfirmVehicleDetails}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorConfirmVehicleDetails(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Please check the details. Server error!
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessConfirmVehicleDetails}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessConfirmVehicleDetails(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Details confirmed successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox
                          mt={2}
                          display="flex"
                          flexDirection={{ xs: "column", lg: "row" }}
                        >
                          <MDBox mr={2}>
                            <MDButton
                              color="success"
                              type="button"
                              marginRight="10px"
                              // disabled={!formik.isValid}
                              onClick={handleLastAsnData}
                            >
                              Copy from last ASN
                            </MDButton>
                          </MDBox>
                          <MDBox mr={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              marginRight="10px"
                              disabled={!formik.isValid}
                            >
                              Submit & Scan BIN/QR On Handheld Application
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openPrintASNModal}
                onClose={handleClosePrintASNModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForDocument}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    {/* <MDTypography>Print ASN</MDTypography> */}

                    {/* <hr /> */}

                    <MDBox pt={1} pb={1} px={3} height="600px" overflow="auto">
                      {/* <iframe
                        style={{
                          height: "100%",
                          width: "100%",
                          overflow: "auto",
                        }}
                        src={ 
                        <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value="hey"
                        viewBox={`0 0 256 256`}
                        />
                    }
                      >
                       
                      </iframe> */}

                      <div ref={componentRef}>
                        <Document>
                          <Page size="A4" style={styles2.page}>
                            {/* {qrs.map((qrdata, categoryIndex) => {
                            <> */}
                            <>
                              <View
                                style={{
                                  marginBottom: "50px",
                                  marginRight: "auto",
                                  marginTop: "20px",
                                  marginLeft: "auto",
                                  width: "100%",
                                }}
                              >
                                <MDBox ml={3.5} mr={1} mt={2}>
                                  <Grid container spacing={2}>
                                    <Grid item lg={4} width="250px">
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Vendor Code
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsVendorCode}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Vendor Name
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsVendorName}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          ASN No
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={asnCode}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          ASN Qty
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsAsnQty}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          No.of packets/bins
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsPacketQty}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Packet Weight
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsPacketWeight}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          PO Line Number
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          name="purchaseOrderLineNumber"
                                          fullWidth
                                          value={
                                            printAsnDetailsPurchaseOrderLineNumber
                                          }
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                            maxLength: 10,
                                          }}
                                        />
                                      </MDBox>
                                    </Grid>

                                    <Grid item lg={4} width="250px">
                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Invoice No
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsInvoiceNo}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Invoice Date
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsInvoiceDate}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Part No
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsPartCode}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Part Description
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsPartDescription}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      {/* <MDBox mb={1} mt={2}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          GRN No
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsGrnNumber}
                                          inputProps={{
                                            style: {
                                              height:"20px"
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox> */}

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Created Date
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsCreatedDate}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Shipped Date
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsShippedDate}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>
                                    </Grid>

                                    <Grid
                                      item
                                      lg={4}
                                      width="250px"
                                      marginBottom={2}
                                    >
                                      {/* <MDBox mb={1} mt={2}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Invoice No
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsInvoiceNo}
                                          inputProps={{
                                            style: {
                                              height:"20px"
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox> */}

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Transporter Type
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsTransporterType}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Transporter Name
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={printAsnDetailsTransporterName}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Vehicle Nameplate
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          fullWidth
                                          value={
                                            printAsnDetailsVehicleNameplate
                                          }
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          LR Number
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          name="lrDocketNo"
                                          fullWidth
                                          value={printAsnDetailsLRNumber}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          Phone Number
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          name="phoneNumber"
                                          fullWidth
                                          value={printAsnDetailsPhoneNumber}
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                            maxLength: 10,
                                          }}
                                        />
                                      </MDBox>

                                      <MDBox mb={1} mt={1}>
                                        <MDTypography
                                          variant="h6"
                                          fontWeight="medium"
                                          flexGrow={1}
                                          style={{
                                            fontWeight: "500",
                                            fontSize: 18,
                                          }}
                                        >
                                          PO Number
                                        </MDTypography>
                                        <MDInput
                                          type="text"
                                          name="purchaseOrderNumber"
                                          fullWidth
                                          value={
                                            printAsnDetailsPurchaseOrderNumber
                                          }
                                          inputProps={{
                                            style: {
                                              height: "20px",
                                              fontSize: "18px",
                                            },
                                            readOnly: true,
                                            maxLength: 10,
                                          }}
                                        />
                                      </MDBox>
                                    </Grid>
                                  </Grid>
                                </MDBox>
                              </View>
                              <View
                                style={{
                                  display: "flex",
                                  // float: "right",
                                  marginTop: "50px",
                                  marginRight: "auto",
                                  marginLeft: "auto",
                                  justifyContent: "center",
                                }}
                              >
                                <QRCode
                                  size={100}
                                  style={{
                                    height: "auto",
                                    maxWidth: "20%",
                                    width: "20%",
                                  }}
                                  value={asnCode}
                                  viewBox={`0 0 156 156`}
                                />
                              </View>
                            </>
                          </Page>
                        </Document>
                      </div>

                      <MDButton
                        color="success"
                        type="button"
                        onClick={handlePrint}
                        style={{
                          marginLeft: "15px",
                          marginTop: "10px",
                          background: "#0BB9B3",
                          color: "white",
                        }}
                      >
                        Print
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openEditASNModal}
                onClose={handleCloseEditASNModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForEditASN}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Update ASN
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseEditASNModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox pb={3} px={1} overflow="auto" height="500px">
                    <MDBox pt={1} px={1}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForEdit.handleSubmit}
                      >
                        <Grid container spacing={4}>
                          <Grid item xs={12} lg={4}>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Part No/Description
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="partNoDes"
                                fullWidth
                                autoComplete="off"
                                value={
                                  singleASNDataForEdit.itemCode +
                                  "/" +
                                  singleASNDataForEdit.itemDescription
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>

                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Po No/Line Number{" "}
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="poNoLineNo"
                                fullWidth
                                autoComplete="off"
                                value={
                                  singleASNDataForEdit.poNumber +
                                  "/" +
                                  singleASNDataForEdit.poLineNumber
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Type of Packet{" "}
                              </MDTypography>

                              <MDInput
                                type="text"
                                name="packageType"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={singleAsnPackageTypeData}
                                error={
                                  formikForEdit.touched.packageType &&
                                  formikForEdit.errors.packageType &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                              {formikForEdit.touched.packageType &&
                                formikForEdit.errors.packageType && (
                                  <TextError
                                    msg={formikForEdit.errors.packageType}
                                  />
                                )}
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Unloading Point{" "}
                              </MDTypography>

                              <MDInput
                                type="text"
                                name="unloadingPoint"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={singleASNDataForEdit.unloadingPoint}
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Delivery Plant{" "}
                              </MDTypography>

                              <MDInput
                                type="text"
                                name="deliveryPlant"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={singleASNDataForEdit.deliveryPlant}
                                error={
                                  formikForEdit.touched.deliveryPlant &&
                                  formikForEdit.errors.deliveryPlant &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "14px",
                                    marginTop: "1px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />

                              {formikForEdit.touched.deliveryPlant &&
                                formikForEdit.errors.deliveryPlant && (
                                  <TextError
                                    msg={formikForEdit.errors.deliveryPlant}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={4}>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Schedule Quantity{" "}
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="scheduleQuantity"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.scheduleQuantity}
                                error={
                                  formikForEdit.touched.scheduleQuantity &&
                                  formikForEdit.errors.scheduleQuantity &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                }}
                              />
                              {formikForEdit.touched.scheduleQuantity &&
                                formikForEdit.errors.scheduleQuantity && (
                                  <TextError
                                    msg={formikForEdit.errors.scheduleQuantity}
                                  />
                                )}
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Balance Quantity
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="balanceQty"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.balanceQty}
                                error={
                                  formikForEdit.touched.balanceQty &&
                                  formikForEdit.errors.balanceQty &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                }}
                              />
                              {formikForEdit.touched.balanceQty &&
                                formikForEdit.errors.balanceQty && (
                                  <TextError
                                    msg={formikForEdit.errors.balanceQty}
                                  />
                                )}
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                ASN Quantity{" "}
                                <Tooltip title="Required" placement="right">
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: 5,
                                      marginBottom: 15,
                                    }}
                                  >
                                    *
                                  </span>
                                </Tooltip>
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="asnQty"
                                fullWidth
                                autoComplete="off"
                                onChange={(e) => {
                                  setAsnQtyChange(e.target.value);
                                  calculatePacketDetails(
                                    e.target.value,
                                    partCode,
                                    vendorsListForPlannerSelected[0]
                                      ? vendorsListForPlannerSelected[0]
                                          .vendorId
                                      : userId,
                                    jwtToken,
                                  );
                                }}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.asnQty}
                                error={
                                  formikForEdit.touched.asnQty &&
                                  formikForEdit.errors.asnQty &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                }}
                              />
                              {formikForEdit.touched.asnQty &&
                                formikForEdit.errors.asnQty && (
                                  <MDBox mb={-3}>
                                    <TextError
                                      msg={formikForEdit.errors.asnQty}
                                    />
                                  </MDBox>
                                )}
                            </MDBox>

                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                No of Packet/Bin{" "}
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="packetNo"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.packetNo}
                                error={
                                  formikForEdit.touched.packetNo &&
                                  formikForEdit.errors.packetNo &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                }}
                              />
                              {formikForEdit.touched.packetNo &&
                                formikForEdit.errors.packetNo && (
                                  <TextError
                                    msg={formikForEdit.errors.packetNo}
                                  />
                                )}
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Unit Pack Quantity{" "}
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="unitPackQty"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.unitPackQty}
                                error={
                                  formikForEdit.touched.unitPackQty &&
                                  formikForEdit.errors.unitPackQty &&
                                  true
                                }
                                // maxLength="4"
                                inputProps={{
                                  // maxLength: 4,
                                  style: {
                                    height: "14px",
                                    marginTop: "2px",
                                  },
                                  readOnly: true,
                                }}
                              />
                              {formikForEdit.touched.unitPackQty &&
                                formikForEdit.errors.unitPackQty && (
                                  <TextError
                                    msg={formikForEdit.errors.unitPackQty}
                                  />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Unit Packet Weight (kg)
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="packetWeight"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={singleAsnPackageWeightData}
                                error={
                                  formikForEdit.touched.packetWeight &&
                                  formikForEdit.errors.packetWeight &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "13px",
                                  },
                                  readOnly: true,
                                  maxLength: 45,
                                }}
                              />
                              {formikForEdit.touched.packetWeight &&
                                formikForEdit.errors.packetWeight && (
                                  <TextError
                                    msg={formikForEdit.errors.packetWeight}
                                  />
                                )}
                            </MDBox>
                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice No{" "}
                                <Tooltip title="Required" placement="right">
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: 5,
                                      marginBottom: 15,
                                    }}
                                  >
                                    *
                                  </span>
                                </Tooltip>
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="invoiceNo"
                                fullWidth
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.invoiceNo}
                                error={
                                  formikForEdit.touched.invoiceNo &&
                                  formikForEdit.errors.invoiceNo &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "12px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formikForEdit.touched.invoiceNo &&
                                formikForEdit.errors.invoiceNo && (
                                  <MDBox mb={-3}>
                                    <TextError
                                      msg={formikForEdit.errors.invoiceNo}
                                    />
                                  </MDBox>
                                )}
                            </MDBox>

                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{
                                  fontWeight: "500",
                                  fontSize: 14,
                                  // marginBottom: "2px",
                                }}
                              >
                                Invoice Date{" "}
                                <Tooltip title="Required" placement="right">
                                  <span
                                    style={{
                                      color: "red",
                                      marginLeft: 5,
                                      // marginBottom: 5,
                                    }}
                                  >
                                    *
                                  </span>
                                </Tooltip>
                              </MDTypography>

                              <MDInput
                                type="date"
                                name="invoiceDate"
                                fullWidth
                                onKeyDown={(e) => e.preventDefault()}
                                autoComplete="off"
                                onChange={formikForEdit.handleChange}
                                onBlur={formikForEdit.handleBlur}
                                value={formikForEdit.values.invoiceDate}
                                error={
                                  formikForEdit.touched.invoiceDate &&
                                  formikForEdit.errors.invoiceDate &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "12.5px",
                                  },

                                  max: currentDate,
                                }}
                              />

                              {formikForEdit.touched.invoiceDate &&
                                formikForEdit.errors.invoiceDate && (
                                  <MDBox mb={-3}>
                                    <TextError
                                      msg={formikForEdit.errors.invoiceDate}
                                    />
                                  </MDBox>
                                )}
                            </MDBox>

                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Invoice (PDF Only)
                                <Tooltip title="Required" placement="right">
                                  {/* <span
                                    style={{
                                      color: "red",
                                      marginLeft: 5,
                                      // marginBottom: 15,
                                    }}
                                  >
                                    *
                                  </span> */}
                                </Tooltip>
                              </MDTypography>
                              <input
                                name="invoiceFile"
                                style={{
                                  borders: "none",
                                  marginTop: "0px",
                                  width: "100%",
                                }}
                                className="choose_file"
                                type="file"
                                autoComplete="off"
                                accept=".pdf"
                                id="chooseFile"
                                onChange={(event) =>
                                  handleChangeForInvoiceFile(event)
                                }
                              />
                            </MDBox>

                            <MDBox mb={3} mt={2}>
                              <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                flexGrow={1}
                                style={{ fontWeight: "500", fontSize: 14 }}
                              >
                                Test Certificate (PDF Only)
                                {/* <span
                                  style={{
                                    color: "red",
                                    marginLeft: 5,
                                    // marginBottom: 15,
                                  }}
                                >
                                  *
                                </span> */}
                              </MDTypography>
                              <input
                                name="testCertificate"
                                style={{
                                  borders: "none",
                                  marginTop: "0px",
                                  width: "100%",
                                  // height:"15px"
                                }}
                                className="choose_file"
                                type="file"
                                autoComplete="off"
                                accept=".pdf"
                                id="chooseFile"
                                onChange={(event) =>
                                  handleChangeForTestCertificate(event)
                                }
                              />
                            </MDBox>
                          </Grid>
                        </Grid>

                        <MDBox>
                          <Collapse in={isErrorEditASN}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorEditASN(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Please check the details. Server error!
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessEditASN}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessEditASN(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              ASN updated successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={2} display="flex">
                          <MDBox mr={2}>
                            <MDButton
                              color="success"
                              type="submit"
                              marginRight="10px"
                              disabled={!formikForEdit.isValid}
                            >
                              Update ASN
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openUpdateCNFQTYModal}
                onClose={handleCloseUpdateCNFQTYModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForVerify}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Verify
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateCNFQTYModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForVerify.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Virtual Bin</MDTypography>
                        <MDInput
                          type="text"
                          name="remark"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForVerify.handleBlur}
                          onChange={formikForVerify.handleChange}
                          value={formikForVerify.values.remark}
                          error={
                            formikForVerify.touched.remark &&
                            formikForVerify.errors.remark &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForVerify.touched.remark &&
                          formikForVerify.errors.remark && (
                            <TextError msg={formikForVerify.errors.remark} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Could not verify the virtual bin!
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Virtual bin verified successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formikForVerify.isValid}
                        >
                          Verify
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openPrintMultipleBinsOfASNModal}
                onClose={handleClosePrintMultipleBinsOfASNModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForDocumentPrint}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Print
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleClosePrintMultipleBinsOfASNModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <MDBox pt={1} pb={1} height="90%">
                      <div ref={component2Ref}>
                        {printData.map((person) => {
                          return (
                            <Document>
                              <Page size="A4" style={styles.page}>
                                <View
                                  style={{
                                    marginBottom: "20px",
                                    marginRight: "0px",
                                    marginTop: "20px",
                                    marginLeft: "20px",
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      marginBottom: "-110px",
                                    }}
                                  >
                                    <thead
                                      style={{
                                        borderSpacing: "5px",
                                        border: "1px solid grey",
                                      }}
                                    >
                                      <tr
                                        style={{
                                          padding: "10px",
                                        }}
                                      >
                                        <th style={{ padding: "10px" }}>
                                          ASN Code
                                        </th>
                                        <th style={{ padding: "10px" }}>
                                          Part Code
                                        </th>
                                        <th style={{ padding: "10px" }}>
                                          Part Description
                                        </th>
                                        <th style={{ padding: "10px" }}>
                                          Bin Code
                                        </th>

                                        <th style={{ padding: "20px" }}>QTY</th>
                                        <th style={{ padding: "20px" }}>
                                          QR Code
                                        </th>
                                      </tr>
                                    </thead>
                                    <hr style={{ width: "670%" }} />
                                    <tbody
                                      style={{
                                        height: "60%",
                                      }}
                                    >
                                      <tr
                                        style={{
                                          padding: "10px",
                                          border: "1px solid grey",
                                          height: "60%",
                                        }}
                                      >
                                        <td
                                          style={{
                                            padding: "10px",
                                          }}
                                        >
                                          {person.asnCode}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                          {person.itemCode}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                          {person.itemDescription}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                          {person.binCode}
                                        </td>
                                        <td style={{ padding: "20px" }}>
                                          {person.qty}
                                        </td>
                                        <td
                                          style={{
                                            padding: "20px",
                                            marginLeft: "50px",
                                          }}
                                        >
                                          <QRCode
                                            size={30}
                                            style={{
                                              height: "auto",
                                              maxWidth: "100%",
                                              width: "100%",
                                            }}
                                            value={person.binCode}
                                            viewBox={`0 0 156 156`}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </View>
                              </Page>
                            </Document>
                          );
                        })}
                      </div>

                      <MDButton
                        color="success"
                        type="button"
                        onClick={handlePrint2}
                        style={{ marginLeft: "10px" }}
                      >
                        Print
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openViewDocumentModal}
                onClose={handleCloseViewDocumentModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForDocument}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      {asnDocumentName}
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseViewDocumentModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox pt={1} pb={3} px={1} height="100%">
                    <iframe
                      src={"data:application/pdf;base64," + asnDocument}
                      title="Document"
                      width="100%"
                      height="900px"
                      style={{
                        border: "none",
                        borderRadius: "16px",
                        boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                        transition: "all 0.3s ease-in-out",
                        position: "relative",
                      }}
                      // onLoad={handleIframeLoad} // Handle iframe load event
                    />
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <ToastContainer />
      {loading2 && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {/* 
      {!loading ? <Footer /> : null} */}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    asnDetailsReducer: state.asnDetailsReducer,
    lastAsnDetailsReducer: state.lastAsnDetailsReducer,
    binsReducer: state.binsReducer,
    packageTypeReducer: state.packageTypeReducer,
    packageDetailsReducer: state.packageDetailsReducer,
    deliveryPlantReducer: state.deliveryPlantReducer,
    unloadingPointReducer: state.unloadingPointReducer,
    packetWeightReducer: state.packetWeightReducer,
    binsForPrintReducer: state.binsForPrintReducer,
    vendorsListForPlannerReducer: state.vendorsListForPlannerReducer,
    postCertificateViewReducer: state.postCertificateViewReducer,
    asnDetailsDownloadReducer: state.asnDetailsDownloadReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getAsnDetails: (
      vendorId,
      status,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getAsnDetails(
          vendorId,
          status,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getAsnDetailsDownload: (
      vendorId,
      status,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getAsnDetailsDownload(
          vendorId,
          status,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getBinsData: (
      asnCode,
      virtual,
      pageNo,
      rowsPerPage,
      searchObjectForBin,
      jwtToken,
    ) =>
      dispatch(
        getBinsData(
          asnCode,
          virtual,
          pageNo,
          rowsPerPage,
          searchObjectForBin,
          jwtToken,
        ),
      ),
    getBinsForPrint: (asnCode, jwtToken) =>
      dispatch(getBinsForPrint(asnCode, jwtToken)),
    updateVehicleDetails: (payload, jwtToken) =>
      dispatch(updateVehicleDetails(payload, jwtToken)),
    printAsn: (payload, jwtToken) => dispatch(printAsn(payload, jwtToken)),
    getLastAsnDetails: (userId, jwtToken) =>
      dispatch(getLastAsnDetails(userId, jwtToken)),
    updateAsn: (payload, jwtToken) => dispatch(updateAsn(payload, jwtToken)),
    calculatePacketWeight: (partCode, asnQtyChange, jwtToken) =>
      dispatch(calculatePacketWeight(partCode, asnQtyChange, jwtToken)),
    getUnloadingPoint: (id, jwtToken) =>
      dispatch(getUnloadingPoint(id, jwtToken)),
    getDeliveryPlant: (id, jwtToken) =>
      dispatch(getDeliveryPlant(id, jwtToken)),
    calculatePacketDetails: (asnQty, partCode, userId, jwtToken) =>
      dispatch(calculatePacketDetails(asnQty, partCode, userId, jwtToken)),
    getPackageType: (partCode, jwtToken) =>
      dispatch(getPackageType(partCode, jwtToken)),
    confirmVirtualBins: (payload, jwtToken) =>
      dispatch(confirmVirtualBins(payload, jwtToken)),
    getVendorsListForPlanner: (jwtToken) =>
      dispatch(getVendorsListForPlanner(jwtToken)),
    postCertificateView: (invoiceDoc, asnCode, vendorUserId, jwtToken) =>
      dispatch(
        postCertificateView(invoiceDoc, asnCode, vendorUserId, jwtToken),
      ),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(AsnDetails);
